module.exports = __webpack_public_path__ + "static/zenlinkpublic-306554627ffab026e5fef521a8cd8928.png";